import { render, staticRenderFns } from "./UsLicenses.vue?vue&type=template&id=84dd984e&scoped=true&"
import script from "./UsLicenses.vue?vue&type=script&lang=js&"
export * from "./UsLicenses.vue?vue&type=script&lang=js&"
import style0 from "./UsLicenses.vue?vue&type=style&index=0&id=84dd984e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dd984e",
  null
  
)

export default component.exports